import(/* webpackMode: "eager" */ "/workspace/src/app/[locale]/(auth)/login/page.tsx");
